import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Store, select } from "@ngrx/store";
import { Observable } from "rxjs";
import { AuthServiceService } from "src/app/shareModule/services/auth-service.service";
import { LocalServiceService } from "src/app/shareModule/services/local-service.service";
import { loadIndividualProducts, selectIndividualProducts } from "src/app/shareModule/states/individual-all-product";

@Injectable({
  providedIn: "root",
})
export class MarketplaceResolver implements Resolve<any> {
  constructor(private auth: AuthServiceService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    let foodId = route.queryParamMap.get("product");
    foodId = foodId ? foodId.split("-").pop() : "";
    if (foodId) {
      return this.auth.get_food_details({ foodId });
    } else {
      return null;
    }
  }
}
